export const STORAGE_KEY = "gerarchiaDrafts";
export const API_BASE =
  window.location.hostname === "localhost"
    ? "http://localhost:8080"
    : "https://api-tradelink.duckdns.org";

export const BASELINE_LEAF_NAME = "Ripetizioni di matematica";

export const genId = () =>
  (crypto?.randomUUID?.() || `tmp_${Date.now()}_${Math.floor(Math.random() * 1e6)}`);
